module.exports = __webpack_public_path__ + "media/images/user-portal-devices-icon-3b6d846f3c1fd612306087bca5f5118f.svg";